import {
  ReduxLoadType,
  ScreenActionReturnType,
  ScreenInitialStateType,
} from "DataTypes/Redux";
import {
  CLEAR_ALERT,
  CLEAR_SCREEN,
  SET_ALERT,
  START_SCREEN_LOAD,
  STOP_SCREEN_LOAD,
} from "./type";
import { AlertProps } from "DataTypes/Common";

const alertInitialState: AlertProps = {
  alertMessage: "",
  openAlert: false,
  alertVariant: "",
};

const screenLoadInitialState: ReduxLoadType = {
  loading: false,
  loadtext: "",
};

const INITIAL_STATE: ScreenInitialStateType = {
  alert: alertInitialState,
  screenLoad: screenLoadInitialState,
};

const reducer = (
  state: ScreenInitialStateType = INITIAL_STATE,
  action: ScreenActionReturnType
): ScreenInitialStateType => {
  switch (action.type) {
    case SET_ALERT:
      if (action.payload && "alertMessage" in action.payload) {
        return {
          ...state,
          alert: action.payload as AlertProps,
        };
      }
      return state;

    case CLEAR_ALERT:
      return {
        ...state,
        alert: alertInitialState,
      };

    case START_SCREEN_LOAD:
      if (action.payload && "loading" in action.payload) {
        return {
          ...state,
          screenLoad: action.payload as ReduxLoadType,
        };
      }
      return state;

    case STOP_SCREEN_LOAD:
      return {
        ...state,
        screenLoad: screenLoadInitialState,
      };

    case CLEAR_SCREEN:
      return {
        ...state,
        alert: alertInitialState,
        screenLoad: screenLoadInitialState,
      };

    default:
      return state;
  }
};

export default reducer;
